export default "__VITE_ASSET__BujO7lDM__"